import React, { Component } from 'react'

import clsx from 'clsx';
import DateFnsUtils from "@date-io/date-fns";
import ruLocale from "date-fns/locale/ru";
import {
  MuiPickersUtilsProvider,
  KeyboardDatePicker,
} from "@material-ui/pickers";
import Icon from './../static/icon'
import { ThemeProvider } from "@material-ui/styles";

import { withStyles } from '@material-ui/core/styles';
import { styles } from './static.inputDateTime';
import { datepickerTheme } from './static.modalDateTime';

import inputStyles from './input.module.scss'

class InputDate extends Component {

  componentDidMount() {
    const { onHandleChangeStore, valueStore, name } = this.props

    const date = new Date()
    var thisDate = new Date(date.getFullYear(), date.getMonth(), date.getDate(), 0, 0, 0)

    if (!!valueStore[name]) {
      var thisValueStore = new Date(valueStore[name].getFullYear(), valueStore[name].getMonth(), valueStore[name].getDate(), 0, 0, 0)

      if (thisDate.getTime() !== thisValueStore.getTime())
        onHandleChangeStore(thisValueStore)
    } else
      onHandleChangeStore(thisDate)
  }

  handleBlur(event) {
    const { onHandleChangeStore } = this.props

    if (!event.target.value)
      onHandleChangeStore(new Date())
  }

  render() {
    const { classes, onHandleChangeStore, valueStore, name, minDate, disabled, maxDate } = this.props

    return (
      <ThemeProvider theme={datepickerTheme}>
        <MuiPickersUtilsProvider utils={DateFnsUtils} locale={ruLocale}>
          <KeyboardDatePicker
            className={clsx(classes.root, inputStyles.inputStyle)}
            ampm={false}
            value={valueStore[name]}
            onChange={onHandleChangeStore}
            onBlur={this.handleBlur.bind(this)}
            inputVariant="outlined"
            keyboardIcon={<Icon name="Subtract1" />}
            mask="__.__.____"
            format="dd.MM.yyyy"
            invalidDateMessage="Неверный формат даты"
            maxDateMessage="Вы выбрали дату позже максимальной"
            minDateMessage="Вы выбрали очень раннюю дату"
            okLabel="Выбрать"
            cancelLabel="Отмена"
            showTodayButton
            todayLabel="Сегодня"
            minDate={minDate}
            disabled={!!disabled ? disabled : false}
            maxDate={maxDate}
            autoOk={true}
          />
        </MuiPickersUtilsProvider>
      </ThemeProvider>
    )
  }
}

export default withStyles(styles)(InputDate)         